const hwconfig = [
{name: 'Actaris Gallus 2000 S1', utility: 'Gas', factor:1},
{name: 'Actaris MultiMag 5/8x3/4', utility:'Water-All',factor:10},
{name: 'AMCO "A" Pulser C700', utility:'Water-All',factor:100},
{name: 'AMCO BK-G1.6', utility:'Gas',factor:1},
{name: 'AMCO G200 (G2D1p)', utility:'Gas',factor:100},
{name: 'AMCO G4 200 CFH',utility:'Gas',factor:1},
{name: 'AMCO InsideR C700', utility:'Water-All',factor:1},
{name: 'AMCO RS Pulser', utility:'Water-All',factor:10},
{name: 'AMCO V100 (PSM-T)', utility:'Water-All',factor:5},
{name: 'Badger Meter DSI-1L', utility:'Water-All',factor:10},
{name: 'Clark Solutions CLXC-C1 (S1)', utility:'Water-All',factor:1},
{name: 'Clark Solutions CLXC-C1 (S10)', utility:'Water-All',factor:10},
{name: 'Clark Solutions CLXC-P (S1)', utility:'Water-All',factor:1},
{name: 'Clark Solutions CLXC-P (S10)', utility:'Water-All',factor:10},
{name: 'E-MON RESI-MON', utility:'Electric',factor:1},
{name: 'Elster C700', utility:'Water-All',factor:1},
{name: 'Energy Billing Sys. G.A.S.', utility:'Runtime',factor:1},
{name: 'Global. Pwr. Products "VT-2"', utility:'Electric',factor:1},
{name: 'Hersey Meter ER-1', utility:'Water-All',factor:5},
{name: 'Hersey Meter ER-2', utility:'Water-All',factor:5},
{name: 'Inovonics MetraMeter', utility:'Water-All',factor:1},
{name: 'Invensus (Sensus) PMX', utility:'Water-All',factor:10},
{name: 'ista Domaqua', utility:'Water-All',factor:10},
{name: 'ista Istameter', utility:'Water-All',factor:10},
{name: 'Itron Dattus', utility:'Gas',factor:10},
{name: 'Itron Metris', utility:'Gas',factor:1},
{name: 'Leviton (IMS) Blue Series 2000', utility:'Electric',factor:1},
{name: 'Leviton (IMS) HVAC Pro-E', utility:'Runtime',factor:36},
{name: 'Leviton (IMS) Mini-Meter', utility:'Electric',factor:1},
{name: 'Master Meter "Elect. Output"', utility:'Water-All',factor:10},
{name: 'MasterMeter FAM', utility:'Water-All',factor:10},
{name: 'MasterTek 450-013', utility:'Runtime',factor:1},
{name: 'MasterTek BK00322', utility:'Runtime',factor:1},
{name: 'MeterLogix POU MIC', utility:'Water-All',factor:1},
{name: 'Minol Minomess 130', utility:'Water-All',factor:1},
{name: 'Minol RTM-3024', utility:'Runtime',factor:1},
{name: 'MTW MJ20 Cold Poly Multi-jet', utility:'Water-Cold',factor:10},
{name: 'MTW MJ20 Short -1 Cold Poly Multi-jet', utility:'Water-Cold',factor:1},
{name: 'MTW MJ20 Short -10 Cold Poly Multi-jet', utility:'Water-Cold',factor:10},
{name: 'MTW MJ420 Hot Poly Multi-jet', utility:'Water-Hot',factor:10},
{name: 'MTW SM15B', utility:'Water-All',factor:5},
{name: 'MTW SM15P', utility:'Water-All',factor:5},
{name: 'Neptune E-CODER', utility:'Water-Encoder',factor:10},
{name: 'Neptune ProCoder', utility:'Water-Encoder',factor:10},
{name: 'Next Century M201C 3/4" Cold Poly Meter', utility:'Water-Cold',factor:10},
{name: 'Next Century M201CH 3/4" Hot Poly Meter', utility:'Water-Hot',factor:10},
{name: 'Norgas NG4', utility:'Gas',factor:1},
{name: 'Norgas RT500', utility:'Runtime',factor:1},
{name: 'Norgas SingleMag', utility:'Water-All',factor:10},
{name: 'Norgas VersaMag', utility:'Water-All',factor:10},
{name: 'Norgas VersaMag-HT', utility:'Water-All',factor:10},
{name: 'Osaki 5124 Electronic', utility:'Electric',factor:1},
{name: 'Osaki 5220 Electronic', utility:'Electric',factor:1},
{name: 'Osaki MTR 9124-K1 Mech.', utility:'Electric',factor:1},
{name: 'Osaki MTR 9220-K1 Mech.', utility:'Electric',factor:1},
{name: 'Other', utility:'Other',factor:1},
{name: 'Schlumberger Gallus 2000 S1', utility:'Gas',factor:1},
{name: 'Siemens ALTIMUS', utility:'Electric',factor:1},
{name: 'Siemens WFK14.E130/US', utility:'Water-All',factor:10},
{name: 'SpireMT 280W', utility:'Water-All',factor:1},
{name: 'United Metering Service UMS2240', utility:'Electric',factor:10},
{name: 'Velocity 9000', utility:'Water-All',factor:10},
{name: 'Zenner PMN02 5/8" x 3/4" cu ft', utility:'Water-Cold',factor:10},
{name: 'Zenner PMN02 5/8" x 3/4" gallon', utility:'Water-Cold',factor:10},
{name: 'Zenner PMN07 1" cu ft', utility:'Water-Cold',factor:10},
{name: 'Zenner PMN07 1" gallon', utility:'Water-Cold',factor:10},
]

export default hwconfig